import { render, staticRenderFns } from "./SelecaoDotacaoOrcamentariaListagem.vue?vue&type=template&id=f1f776a6&scoped=true"
import script from "./SelecaoDotacaoOrcamentariaListagem.vue?vue&type=script&lang=js"
export * from "./SelecaoDotacaoOrcamentariaListagem.vue?vue&type=script&lang=js"
import style0 from "./SelecaoDotacaoOrcamentariaListagem.vue?vue&type=style&index=0&id=f1f776a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f776a6",
  null
  
)

export default component.exports